import { Typography } from '@material-ui/core'
import React from 'react'
import { Link } from 'gatsby'

import { colors } from '../../theme'

import { useStyles } from './styles'

const ButtonComponent = ({
  type,
  text,
  width,
  callToAction,
  url,
  state,
  height,
  fontSize,
  id,
  onClick,
}) => {
  const classes = useStyles()

  if (type === 'orange') {
    return (
      <>
        {callToAction ? (
          <Link
            style={{
              fontSize: fontSize ? fontSize : '1rem',
              height: height ? height : 50,
              width: width ? width : 146,
            }}
            href={callToAction === 'phone' ? `tel:${url}` : null}
            to={callToAction === 'url' ? url : null}
            className={classes.buttonOrange}
            state={state ? state : {}}
            onClick={() => onClick()}
            activeStyle={{ color: "red" }}
            role="button"
            aria-label="Call service helpline" 
          >
            <Typography
              style={{
                fontSize: fontSize ? fontSize : '1rem',
              }}
              className={classes.buttonText}
            >
              {text}
            </Typography>
          </Link>
        ) : (
          <div
            style={{
              width: width ? width : 146,
              height: height ? height : 50,
              fontSize: fontSize ? fontSize : '1rem',
            }}
            id={id}
            className={classes.buttonOrange}
            onClick={() => onClick()}
          >
            <Typography
              style={{
                fontSize: fontSize ? fontSize : '1rem',
              }}
              className={classes.buttonText}
            >
              {text}
            </Typography>
          </div>
        )}
      </>
    )
  }

  return (
    <Link
      style={{
        width: width ? width : 146,
        height: height ? height : 50,
        
        fontSize: fontSize ? fontSize : '1rem',
      }}
      href={callToAction === 'phone' ? `tel:${url}` : ''}
      to={callToAction === 'url' ? url : ''}
      role="button"
      className={classes.buttonLine}
      state={state ? state : {}}
    >
      <Typography
        style={{
          fontSize: fontSize ? fontSize : '1rem',
        }}
        className={classes.buttonText}
      >
        {text}
      </Typography>
    </Link>
  )
}

export { ButtonComponent }
